// @ts-nocheck

import { useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { useAppContext } from '../../../contexts/AppContextProvider';
import { selectUserConnected } from '../../../selectors/user/userPrimary.selector';
import { openGRView } from '../utils/routes';

const useOpenGRView = () => {
  const history = useHistory();
  const isUserConnected = useSelector(selectUserConnected);
  const { setOnLoginSucceed } = useAppContext();
  const userIsConnectedTimeoutRef = useRef(null);

  return useCallback(() => {
    openGRView(history, { isUserConnected, setOnLoginSucceed, userIsConnectedTimeoutRef });
  }, [history, isUserConnected, setOnLoginSucceed]);
};

export default useOpenGRView;
